import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Car, Anchor, Shield, AlertTriangle, Heart, Bike } from 'lucide-react';

const practiceAreasData = [
  { 
    slug: 'car-crashes', 
    title: 'Car Crashes', 
    icon: Car,
    shortDesc: 'Auto accident representation'
  },
  { 
    slug: 'maritime-injuries', 
    title: 'Maritime Injuries', 
    icon: Anchor,
    shortDesc: 'Jones Act & seaman claims'
  },
  { 
    slug: 'motorcycle-crashes', 
    title: 'Motorcycle Crashes', 
    icon: Bike,
    shortDesc: 'Motorcycle accident cases'
  },
  { 
    slug: 'first-responder-crashes', 
    title: 'First Responder Crashes', 
    icon: Shield,
    shortDesc: 'Police & peace officer injuries'
  },
  { 
    slug: 'slip-and-falls', 
    title: 'Slip and Falls', 
    icon: AlertTriangle,
    shortDesc: 'Premises liability claims'
  },
  { 
    slug: 'wrongful-death', 
    title: 'Wrongful Death', 
    icon: Heart,
    shortDesc: 'Loss of loved ones'
  },
];

const RelatedPracticeAreas = ({ currentSlug, title = "Related Practice Areas" }) => {
  // Filter out the current page
  const relatedAreas = practiceAreasData.filter(area => area.slug !== currentSlug);
  
  // Show max 4 related areas
  const displayAreas = relatedAreas.slice(0, 4);

  return (
    <section className="py-16 bg-slate-50" data-testid="related-practice-areas">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-secondary text-center mb-10">
          {title}
        </h2>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {displayAreas.map((area) => {
            const Icon = area.icon;
            return (
              <Link
                key={area.slug}
                to={`/${area.slug}`}
                className="group bg-white rounded-xl p-6 text-center hover:shadow-lg transition-all hover:-translate-y-1"
              >
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-teal-200 transition-colors">
                  <Icon className="w-6 h-6 text-teal-600" />
                </div>
                <h3 className="font-heading font-semibold text-secondary mb-1 group-hover:text-teal-600 transition-colors">
                  {area.title}
                </h3>
                <p className="text-sm text-slate-500">
                  {area.shortDesc}
                </p>
                <span className="inline-flex items-center gap-1 text-sm text-teal-600 mt-3 opacity-0 group-hover:opacity-100 transition-opacity">
                  Learn more <ChevronRight className="w-4 h-4" />
                </span>
              </Link>
            );
          })}
        </div>
        
        <div className="text-center mt-8">
          <Link 
            to="/areas-we-serve"
            className="inline-flex items-center gap-2 text-teal-600 font-medium hover:text-teal-700 transition-colors"
          >
            View All Practice Areas
            <ChevronRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default RelatedPracticeAreas;
